import GenerateStep from "types/enums/GenerateStep";

export default function getGenerateStepIndex(step: GenerateStep): number {
  return Object.values(GenerateStep).indexOf(step);
}
